'use strict';

import Fullscreen from './fullscreen.js';
import {Fancybox} from '@fancyapps/ui/src/Fancybox/Fancybox.js';

export default class PictureShow {
    initialize() {
        let element = document.querySelector('.js-picture-show');
        if (element) {
            this.initializeElement(element);
        }
    }

    initializeElement(element) {
        let picture = element.querySelector('.picture');

            if (picture.closest('.fancybox__slide')) {
                // Inside Fancybox: clicking the image closes the current lightbox
                const img = picture.querySelector('img');
                if (img) {
                    img.addEventListener('click', (e) => {
                        e.stopPropagation();
                        const inst = Fancybox.getInstance();
                        if (inst) inst.close();
                    });
                }

                // Magnifier overlay opens nested Fancybox with original image
                const overlayLink = picture.querySelector('.overlay-link[data-fancybox]');
                if (overlayLink) {
                    overlayLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const src = overlayLink.getAttribute('data-src') || overlayLink.getAttribute('href');
                        if (src) {
                            Fancybox.show([{ src, type: 'image' }], {
                                Toolbar: {
                                    autoEnable: true,
                                    display: [
                                        { id: 'zoom', position: 'right' },
                                        { id: 'download', position: 'right' },
                                        { id: 'close', position: 'right' },
                                    ],
                                },
                                idle: false,
                                contentClick: 'close',
                                hideScrollbar: false,
                                trapFocus: true,
                                on: {
                                    done: (fancybox, slide) => {
                                        const rearmAutoHide = (el, duration = 3500) => {
                                            if (!el) return;
                                            el.classList.add('auto-hide');
                                            el.classList.add('show-once');
                                            if (el.__hideTimer) { clearTimeout(el.__hideTimer); }
                                            el.__hideTimer = setTimeout(() => {
                                                el.classList.remove('show-once');
                                                el.__hideTimer = null;
                                            }, duration);
                                        };
                                        const mount = slide.$el?.querySelector?.('.fancybox__content') || slide.$el;
                                        if (mount && !mount.querySelector('.sb-fb-overlay-close')) {
                                            const closeBar = document.createElement('div');
                                            closeBar.className = 'sb-fb-overlay-close auto-hide show-once';
                                            closeBar.setAttribute('title', 'Schließen');
                                            closeBar.innerHTML = '<span class="sb-fb-close-inner"><i class="fas fa-times"></i><span>Schließen</span></span>';
                                            closeBar.addEventListener('click', (ev) => {
                                                ev.preventDefault();
                                                ev.stopPropagation();
                                                fancybox.close();
                                            });
                                            mount.appendChild(closeBar);
                                            setTimeout(() => closeBar.classList.remove('show-once'), 4000);

                                            const armFromEvent = (ev) => {
                                                const target = ev.target;
                                                if (target && (target.closest('.fancybox__toolbar') || target.closest('.sb-fb-overlay-close'))) {
                                                    return;
                                                }
                                                rearmAutoHide(closeBar);
                                            };
                                            mount.addEventListener('pointerdown', armFromEvent, { passive: true });
                                            mount.addEventListener('wheel', armFromEvent, { passive: true });
                                            try {
                                                if (slide.Panzoom && slide.Panzoom.on) {
                                                    slide.Panzoom.on('start', () => rearmAutoHide(closeBar));
                                                    slide.Panzoom.on('afterUpdate', () => rearmAutoHide(closeBar));
                                                }
                                            } catch (e) {}
                                        }
                                    },
                                },
                            });
                        }
                    });
                }
        } else {
            let fullscreen = new Fullscreen(picture.querySelector('img'));
            picture.addEventListener('click', () => {
                fullscreen.toggleFullscreen();
            });

                // Ensure overlay link opens Fancybox reliably
            const overlayLink = element.querySelector('.overlay-link[data-fancybox]');
                if (overlayLink) {
                    overlayLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        const src = overlayLink.getAttribute('data-src') || overlayLink.getAttribute('href');
                        if (src) {
                            Fancybox.show([{src, type: 'image'}], {
                                Toolbar: {
                                    autoEnable: true,
                                    display: [
                                        { id: 'zoom', position: 'right' },
                                        { id: 'download', position: 'right' },
                                        { id: 'close', position: 'right' },
                                    ],
                                },
                                idle: false,
                                contentClick: 'close',
                                hideScrollbar: false,
                                trapFocus: true,
                                on: {
                                    done: (fancybox, slide) => {
                                        const rearmAutoHide = (el, duration = 3500) => {
                                            if (!el) return;
                                            el.classList.add('auto-hide');
                                            el.classList.add('show-once');
                                            if (el.__hideTimer) { clearTimeout(el.__hideTimer); }
                                            el.__hideTimer = setTimeout(() => {
                                                el.classList.remove('show-once');
                                                el.__hideTimer = null;
                                            }, duration);
                                        };
                                        const mount = slide.$el?.querySelector?.('.fancybox__content') || slide.$el;
                                        if (mount && !mount.querySelector('.sb-fb-overlay-close')) {
                                            const closeBar = document.createElement('div');
                                            closeBar.className = 'sb-fb-overlay-close auto-hide show-once';
                                            closeBar.setAttribute('title', 'Schließen');
                                            closeBar.innerHTML = '<span class="sb-fb-close-inner"><i class="fas fa-times"></i><span>Schließen</span></span>';
                                            closeBar.addEventListener('click', (ev) => {
                                                ev.preventDefault();
                                                ev.stopPropagation();
                                                fancybox.close();
                                            });
                                            mount.appendChild(closeBar);
                                            setTimeout(() => closeBar.classList.remove('show-once'), 4000);

                                            const armFromEvent = (ev) => {
                                                const target = ev.target;
                                                if (target && (target.closest('.fancybox__toolbar') || target.closest('.sb-fb-overlay-close'))) {
                                                    return;
                                                }
                                                rearmAutoHide(closeBar);
                                            };
                                            mount.addEventListener('pointerdown', armFromEvent, { passive: true });
                                            mount.addEventListener('wheel', armFromEvent, { passive: true });
                                            try {
                                                if (slide.Panzoom && slide.Panzoom.on) {
                                                    slide.Panzoom.on('start', () => rearmAutoHide(closeBar));
                                                    slide.Panzoom.on('afterUpdate', () => rearmAutoHide(closeBar));
                                                }
                                            } catch (e) {}
                                        }
                                    },
                                },
                            });
                        }
                    });
                }
        }
    }
}
